// extracted by mini-css-extract-plugin
export var canShowLeftLogo = "LeftRightContainer-module--canShowLeftLogo--eaf6f";
export var canShowRightLogo = "LeftRightContainer-module--canShowRightLogo--3e21d";
export var gridBox = "LeftRightContainer-module--gridBox--9809f";
export var left = "LeftRightContainer-module--left--18e18";
export var leftRightContainer = "LeftRightContainer-module--leftRightContainer--e5cbc";
export var logo = "LeftRightContainer-module--logo--434ee";
export var mobileBottomImage = "LeftRightContainer-module--mobileBottomImage--7131a";
export var right = "LeftRightContainer-module--right--6caa5";
export var rightSection = "LeftRightContainer-module--rightSection--fc36c";